import { render, staticRenderFns } from "./SetSchool.vue?vue&type=template&id=18da5a1e"
import script from "./SetSchool.vue?vue&type=script&lang=js"
export * from "./SetSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports